import { useAuth } from 'react-oidc-context';
import { TrainingToolCards } from './TrainingToolCard';
import { useToFetchTrainingTools } from '../hooks/useToFetchTraningTools';
import Breadcrumbs from './Breadcrumbs';
import { DoctorTrainingToolsListProps } from '../interface/interface';

export function TrainingToolList({
  fetchResources,
}: DoctorTrainingToolsListProps) {
  const { user } = useAuth();
  const [resources] = useToFetchTrainingTools(
    user!.access_token,
    fetchResources,
  );

  if (!resources?.length) {
    return <p className="font-semibold text-center">No Resources to display</p>;
  }

  return (
    <>
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            href: '/doctors',
            children: <>Doctors</>,
          },
          {
            tag: 'p',
            children: <span>Resource Hub</span>,
          },
        ]}
      />
      <section aria-labelledby="list" className="h-full">
        <div
          className="overflow-hidden rounded-lg bg-white shadow overflow-y-auto max-h-[720px] [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
        >
          <div className="p-6">
            <TrainingToolCards resources={resources} />
          </div>
        </div>
      </section>
    </>
  );
}
